import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Box, { BoxProps } from '@mui/material/Box';

import { CateringOptionName_cateringOption$key } from '__generated__/CateringOptionName_cateringOption.graphql';

type Props = BoxProps & {
  cateringOption: CateringOptionName_cateringOption$key;
};

const CateringOptionName: FC<Props> = ({ cateringOption, ...props }) => {
  const { name, etgKey } = useFragment(
    graphql`
      fragment CateringOptionName_cateringOption on CateringOption {
        name
        etgKey
      }
    `,
    cateringOption
  );

  return (
    <Box component="span" {...props}>
      {name || `[${etgKey}]`}
    </Box>
  );
};

export default CateringOptionName;
